<template>
    <div id='box' class="dsr_box" v-if="error">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title text-uppercase" v-if="error.title">{{ error.title }}</h4>
                <p class="card-text text-secondary" v-if="error.message">{{ error.message }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'error',
  props: {
    error: null
  }
}
</script>

<style lang='scss' scoped>
@import '../../../scss/global.scss';

.text-secondary::first-letter {
    text-transform: uppercase;
}

.card {
    background-color: initial!important;
    //color: white!important;
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/error/error.vue